import { sanitizeHtmlForDisplay } from "./htmlSanitizer";

export function captionHtmlForDisplay(html: string | null | undefined): string {
  if (!html || !html.trim()) {
    return "";
  }

  const clean = sanitizeHtmlForDisplay(html);
  return clean.replace(/<a\b([^>]*)>/gi, (_match, attrs: string) => {
    const withoutTarget = attrs
      .replace(/\s*target\s*=\s*(['"]).*?\1/gi, "")
      .replace(/\s*rel\s*=\s*(['"]).*?\1/gi, "");
    return `<a${withoutTarget} target="_blank" rel="noopener noreferrer">`;
  });
}
